/**
 * 品牌標記 —— 與 assets/icon.svg 同一份幾何，內嵌成元件避免多一次網路請求。
 * 兩端擋板 + 向外的箭頭 = 「展開」，在 16px 也還讀得出來。
 */
export function Mark({ class: className }: { class?: string }) {
  return (
    <svg viewBox="0 0 512 512" class={className} role="img" aria-label="deShorten">
      <title>deShorten</title>
      <defs>
        <linearGradient id="mark-bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stop-color="#4F46E5" />
          <stop offset="1" stop-color="#22D3EE" />
        </linearGradient>
      </defs>
      <rect width="512" height="512" rx="116" fill="url(#mark-bg)" />
      <g fill="#fff">
        <rect x="84" y="168" width="32" height="176" rx="16" />
        <rect x="396" y="168" width="32" height="176" rx="16" />
        <rect x="188" y="240" width="136" height="32" rx="16" />
        <path d="M132 256 L196 206 L196 306 Z" />
        <path d="M380 256 L316 206 L316 306 Z" />
      </g>
    </svg>
  )
}
